export enum WorkOrderEnum {
  New, //0
  "In Progress", //1
  "Pending Payment", //2
  Completed, //3
  Archived, //4
  Cancelled, //5
  Overdue, //6
  "Pending Schedule", //7
}

export enum WorkOrderEnumClass {
  'bg-info', //new
  'bg-warning', //in progress
  'bg-orangey', //pending payment
  'bg-success', //completed
  'bg-dark', //archived
  'bg-grey', //cancelled
  'bg-danger', //overdue
  'bg-pinkish',//Pending Schedule
}

export namespace WorkOrderStatusList {
  export function keys(): Array<string> {
    var keys = Object.keys(WorkOrderEnum);
    return keys.slice(keys.length / 2, keys.length);
  }
}